/**
 * sale basket line Vue component
 * need include rest.client, citrus.vuex.store
 * @package citrus.vue.basket.line
 */
import {Vue} from "ui.vue";

let BasketLine = {
	name: 'BasketLine',
	store: BX.Citrus.Vuex.store,
	mixins: [BX.Citrus.Vue.Component.FormatMixin],
	props: {

	},
	data: function () {
		return {
			params: {
				SHOW_PRODUCTS: 'N',
				SHOW_IMAGE: 'N',
				SHOW_PRICE: 'N',
				SHOW_TOTAL_PRICE: 'Y',
				PATH_TO_BASKET: '/personal/cart/',
				SHOW_NUM_PRODUCTS: 'Y',
				SHOW_EMPTY_VALUES: 'N',
			},
			result: {
				items: [],
				num_products: 0,
				total_price: "",
				disable_use_basket: false
			},
			siteId: "",
			ajaxPath: "",
			templateName: "",
			opened: false,
			loading: false,
			cutlery: [],
		};
	},
	created: function () {
		document.addEventListener('click', this.clickOutside);
		this.$on('hook:beforeDestroy', () => document.removeEventListener('click', this.clickOutside));

		BX.addCustomEvent("OnBasketChange", this.refresh);
		Vue.event.$on("Citrus.Component.Basket:update", this.refresh);
	},
	beforeDestroy() {
		BX.removeCustomEvent("OnBasketChange", this.refresh);
		Vue.event.$off("Citrus.Component.Basket:update", this.refresh);
	},
	mounted: function ()
	{
		BX.onCustomEvent("Citrus.Component.Basket:init", [this]);
	},
	computed: {
		loc() {
			return Vue.getFilteredPhrases("TSB1_");
		},
		count() {
			return this.result.num_products > 99 ? "99+" : this.result.num_products;
		},
		countText() {
			return this.declension(this.result.num_products > 99 ? 99 : this.result.num_products, [
				this.loc.TSB1_BASKET_PRODUCTS_COUNT_1,
				this.loc.TSB1_BASKET_PRODUCTS_COUNT_4,
				this.loc.TSB1_BASKET_PRODUCTS_COUNT_5,
			]);
		},
		totalFormatted() {
			return this.formatPrice(this.result.total_price, false);
		},
	},
	methods: {
		declension(value, words) {
			value = Math.abs(value) % 100;
			var num = value % 10;
			if (value > 10 && value < 20) return words[2];
			if (num > 1 && num < 5) return words[1];
			if (num == 1) return words[0];
			return words[2];
		},
		clickOutside(e) {
			if (!this.$el.contains(e.target)) {
				this.opened = false;
			}
		},
		openCard() {
			this.opened = true;

			if (this.$gtag) {
				this.$gtag.event(this.$metrika.Goal.BASKET_CLICK);
			}

			if (this.$metrika) {
				this.$metrika.reachGoal(this.$metrika.Goal.BASKET_CLICK);
			}
		},
		setResult: function(result) {
			this.result = result;
			let productToBasket = {};
			for (let key in this.result.items) {
				let item = this.result.items[key];
				productToBasket[item.product_id] = item.quantity;
				Vue.event.$emit("Citrus.Vue.Product:addedToBasket:" + item.product_id, {
					basketItem: item.id,
					name: "sale-basket-line"
				});
			}

			this.$store.dispatch('basket/load', productToBasket);
		},
		refresh: function () {
			if (this.loading)
				return;

			this.loading = true;

			BX.ajax({
				url: this.ajaxPath,
				method: 'POST',
				dataType: 'json',
				timeout: 30,
				data: BX.ajax.prepareData({
					sessid: BX.bitrix_sessid(),
					siteId: this.siteId,
					templateName: this.templateName,
					arParams: this.params,
				}),
				onsuccess: (response) => {
					this.loading = false;
					this.result = response;
				},
				onfailure: (error) => {
					this.loading = false;
					console.error(error);
				}
			});
		},
	}
};

export {BasketLine};
export default {BasketLine};
